import { Component, type ErrorInfo, type ReactNode } from 'react';
import { RefreshCw, ShieldCheck } from 'lucide-react';
import { reportClientError } from '../lib/monitoring';

interface Props { children: ReactNode }
interface State { failed: boolean; reference: string }

export class AppErrorBoundary extends Component<Props, State> {
  state: State = { failed: false, reference: '' };

  static getDerivedStateFromError(): State {
    return { failed: true, reference: crypto.randomUUID().slice(0, 8).toUpperCase() };
  }

  componentDidCatch(error: Error, info: ErrorInfo) {
    console.error('BilaFlow render error', error, info.componentStack);
    void reportClientError({ severity: 'fatal', code: 'react_render_error', message: error.message, fingerprint: this.state.reference });
  }

  render() {
    if (!this.state.failed) return this.props.children;
    return <main className="fatal-error-shell">
      <section className="fatal-error-card" role="alert">
        <div className="fatal-error-icon"><ShieldCheck size={27} /></div>
        <span className="eyebrow">ระบบขัดข้องชั่วคราว</span>
        <h1>เปิดหน้านี้ไม่สำเร็จ</h1>
        <p>ข้อมูลเอกสารในอุปกรณ์ยังไม่ถูกลบ กรุณาโหลดหน้าใหม่แล้วลองอีกครั้ง</p>
        <code className="fatal-error-reference">รหัสอ้างอิง {this.state.reference}</code>
        <button className="btn primary" type="button" onClick={() => window.location.reload()}><RefreshCw size={17} /> โหลดหน้าใหม่</button>
      </section>
    </main>;
  }
}
